import { z } from "@/helpers/forms/zod";

export type SetupUserFormType = z.infer<typeof setupUserFormSchema>;
export const setupUserFormSchema = z.object({
  firstName: z.string().min(2),
  lastName: z.string().min(2),
});
